import styled from 'styled-components';
import { lighten } from 'polished';

function thumbCommon(theme) {
  return `
  height: 16px;
  width: 16px;
  border-radius: 100%;
  background: ${theme.palette.primary[0]};
  cursor: pointer;
`;
}

const trackCommon = (theme) => `
  width: 100%;
  height: 4px;
  cursor: pointer;
  background: ${lighten(0.25, theme.palette.primary[0])};
  border-radius: 1rem;
  margin-bottom: 6px;
`;

const RangeSelector = styled.input.attrs({
  type: 'range',
})`
  &::-webkit-slider-thumb {
    ${({ theme }) => thumbCommon(theme)} -webkit-appearance: none;
    margin-top: -6px; /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
  }

  &::-moz-range-thumb {
    ${({ theme }) => thumbCommon(theme)};
  }

  &::-ms-thumb {
    ${({ theme }) => thumbCommon(theme)};
  }

  &::-webkit-slider-runnable-track {
    ${({ theme }) => trackCommon(theme)};
  }

  &::-moz-range-track {
    ${({ theme }) => trackCommon(theme)};
  }

  &::-ms-track {
    ${({ theme }) => trackCommon(theme)} background: transparent;
    border-color: transparent;
    border-width: 16px 0;
    color: transparent;
  }

  &::-ms-fill-lower,
  &::-ms-fill-upper {
    ${({ theme }) => trackCommon(theme)};
  }
`;

export default RangeSelector;
